import { render, staticRenderFns } from "./DlgPostsDelete.vue?vue&type=template&id=116d0295&scoped=true&"
import script from "./DlgPostsDelete.vue?vue&type=script&lang=ts&"
export * from "./DlgPostsDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d0295",
  null
  
)

export default component.exports